import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import WhatsAppChatWidget from "./WhatsAppChatWidget";

// Project data — now each project has multiple images
const projects = [
  {
    images: [
      "assets/img/ss_plates/ss_plate_handle_01.jpg",
      "assets/img/ss_plates/ss_plate_handle_02.jpg",
      "assets/img/ss_plates/ss_plate_handle_03.jpg",      
    ],
    title: "SS Plate with Handle",
    description:
      "Vishu Shethra Industries proudly manufactures its patent-rights-protected SS Plate with Handle, designed for superior strength, safety, and convenience. Made from premium-grade stainless steel, it offers a secure grip, excellent durability, corrosion resistance, and long-lasting performance. Ideal for homes, hotels, restaurants, and catering services, it combines innovation with reliable quality.",
  },
  {
    images: [
      "assets/img/ss_plates/ss_plate_4_cups_01.jpg",
      "assets/img/ss_plates/ss_plate_4_cups_02.jpg",
      "assets/img/ss_plates/ss_plate_4_cups_03.jpg",
      "assets/img/ss_plates/ss_plate_4_cups_04.jpg",
      "assets/img/ss_plates/ss_plate_4_cups_05.jpg",
    ],
    title: "SS Plate with 4 Cups",
    description:
      "Vishu Shethra Industries proudly presents its patent-rights-protected SS Plate with 4 Cups. Designed with a detachable handle for convenience, this premium stainless steel serving plate offers durability, hygiene, and elegant presentation. Ideal for homes, restaurants, and catering, it ensures easy handling, cleaning, and long-lasting performance with innovative functionality.",
  },
  
  {
    images: [
      "assets/img/ss_plates/ss_plate_3_cups_01.jpg",
      "assets/img/ss_plates/ss_plate_3_cups_02.jpg",
      "assets/img/ss_plates/ss_plate_3_cups_03.jpg",
    ],
    title: "SS Plate with 3 Cups",
    description:
      "Vishu Shethra Industries is proud to introduce its Patented SS Plate with 3 Cups, an innovative stainless steel dining solution designed for durability, convenience, and hygiene. Crafted from premium-quality stainless steel, this unique patented product features three integrated cups for serving multiple food items efficiently. Ideal for homes, schools, hostels, hospitals, restaurants, and catering services, it offers a practical, elegant, and long-lasting solution for organized and comfortable dining.",
  },
  {
    images: [
      "assets/img/ss_plates/ss_plate_multicup_01.jpg",
      "assets/img/ss_plates/ss_plate_multicup_02.jpg",
    ],
    title: "SS Plate Multi Cups",
    description:
      "Vishu Shethra Industries presents the Patented SS Plate Multi Cups, combining innovation with everyday functionality. Designed using high-quality stainless steel, it allows convenient serving of multiple dishes in one plate. Strong, hygienic, and reusable, it is an ideal choice for homes, institutions, restaurants, catering services, and commercial kitchens. Experience smarter dining with the Patented SS Plate Multi Cups from Vishu Shethra Industries.",
  },
];

const ImageCarousel = ({ images, altText }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const goNext = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    if (!images || images.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }, 3000);

    return () => clearInterval(interval);
  }, [images]);

  if (!images || images.length === 0) return null;

  return (
    <div className="position-relative overflow-hidden">
      <img
        src={images[currentIndex]}
        alt={altText}
        className="card-img-top"
        style={{ objectFit: "cover", height: "320px" }}
      />

      {images.length > 1 && (
        <>
          <button
            type="button"
            onClick={goPrev}
            aria-label="Previous image"
            className="btn btn-light position-absolute top-50 start-0 translate-middle-y ms-2 rounded-circle shadow"
            style={{ width: "42px", height: "42px", zIndex: 2 }}
          >
            &#10094;
          </button>

          <button
            type="button"
            onClick={goNext}
            aria-label="Next image"
            className="btn btn-light position-absolute top-50 end-0 translate-middle-y me-2 rounded-circle shadow"
            style={{ width: "42px", height: "42px", zIndex: 2 }}
          >
            &#10095;
          </button>
        </>
      )}
    </div>
  );
};

const IronSteel = () => {
  const pageTitle =
    "Iron & Steel Projects - VishuShethra Industries | Bridge Fencing & Handrail Works";
  const pageDescription =
    "Explore VishuShethra Industries' iron and steel project portfolio — MS fencing and handrail works completed across Lucas Bridge, Vadapalani Metro, Vandalur, Anna Nagar, and Kanchiwaram bridges.";
  const pageUrl = "https://vishushethra.com/iron-and-steel";

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={pageUrl} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
      </Helmet>

      {/* Banner Section */}
      <div className="banner-section">
        <img
          src="./assets/img/bannerbreadcrumbs.png"
          alt="Banner"
          className="img-fluid banner-img"
        />
        <div className="breadcrumb-container">
          <h2>SS &amp; Plates</h2>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                SS Plates
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Intro */}
      <div className="container py-5">
        <h2 className="text-center mb-3">Stainless Steel Plates (SS Plates)</h2>
        <p className="text-center text-justify mx-auto" style={{ maxWidth: "800px" }}>
          SS Handle Plates designed for strength, durability, and a modern finish.
        </p>
      </div>

      {/* Projects Grid */}
      <div className="container pb-5">
        <div className="row">
          {projects.map((project, index) => (
            <div className="col-md-6 mb-5" key={index}>
              <div className="card h-100 shadow border-0">
                <ImageCarousel
                  images={project.images}
                  altText={project.title}
                />
                <div className="card-body p-4">
                  <h4 className="card-title mb-3">{project.title}</h4>
                  <p className="card-text text-justify">{project.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <WhatsAppChatWidget
        phoneNumber="+919488828030"
        companyName="VishuShethra Industries"
      />
    </>
  );
};

export default IronSteel;